module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/6th/campaign_banner_sp@2x_73ab1a857556baf7a309e3aa7a46e883.jpg";